import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-night-bg safe-area-top safe-area-bottom">
      <header className="sticky top-0 z-10 safe-area-top bg-white dark:bg-night-surface border-b border-gray-100 dark:border-night-card">
        <div className="max-w-2xl mx-auto px-4 h-14 flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            aria-label="Go back"
            className="p-2 -ml-2 rounded-lg hover:bg-gray-100 dark:hover:bg-night-card text-gray-700 dark:text-night-text"
          >
            <ArrowLeft size={22} />
          </button>
          <h1 className="text-base font-semibold text-gray-900 dark:text-night-text">Terms of Use</h1>
        </div>
      </header>

      <main className="max-w-2xl mx-auto px-4 py-6 text-sm text-gray-700 dark:text-night-text leading-relaxed [&_h2]:text-base [&_h2]:font-semibold [&_h2]:text-gray-900 dark:[&_h2]:text-night-text [&_h2]:mt-6 [&_h2]:mb-2 [&_p]:mb-3 [&_ul]:list-disc [&_ul]:pl-5 [&_ul]:mb-3 [&_li]:mb-1 [&_strong]:text-gray-900 dark:[&_strong]:text-night-text">
        <p className="text-sm text-gray-500 dark:text-night-muted">
          <strong>Cooksmith</strong> — A product by Wolf Technologies Ltd<br />
          Effective date: 17 April 2026
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>By downloading, installing, or using the Cooksmith application ("App"), you agree to be bound by these Terms of Use ("Terms"). If you do not agree to these Terms, do not use the App.</p>

        <h2>2. Description of Service</h2>
        <p>Cooksmith is a recipe management application that allows you to browse recipes, save favourites, create meal plans, generate grocery lists, and use step-by-step cooking mode. The App is provided by Wolf Technologies Ltd ("we", "us", "our").</p>

        <h2>3. Account Registration</h2>
        <p>To use certain features of the App, you must create an account. You agree to provide accurate information and to keep your login credentials secure. You are responsible for all activity under your account.</p>

        <h2>4. User Content</h2>
        <p>You retain ownership of any recipes, meal plans, or other content you create within the App ("User Content"). By using the App, you grant us a limited licence to store and display your User Content solely for the purpose of providing the service to you.</p>

        <h2>5. Acceptable Use</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the App for any unlawful purpose.</li>
          <li>Attempt to gain unauthorised access to our systems or other users' accounts.</li>
          <li>Interfere with or disrupt the App or its servers.</li>
          <li>Reverse-engineer, decompile, or disassemble any part of the App.</li>
          <li>Use automated tools to scrape or collect data from the App.</li>
        </ul>

        <h2>6. Intellectual Property</h2>
        <p>The App, including its design, code, recipe catalogue, and branding, is the property of Wolf Technologies Ltd and is protected by intellectual property laws. You may not copy, modify, or distribute any part of the App without our written consent.</p>

        <h2>7. Disclaimer of Warranties</h2>
        <p>The App is provided "as is" without warranties of any kind, either express or implied. We do not warrant that the App will be uninterrupted, error-free, or free of harmful components. Recipe information, including nutrition data, is provided for general guidance only and should not be relied upon as medical or dietary advice.</p>

        <h2>8. Limitation of Liability</h2>
        <p>To the maximum extent permitted by law, Wolf Technologies Ltd shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the App.</p>

        <h2>9. Account Deletion</h2>
        <p>You may delete your account at any time via the Settings page within the App. Upon deletion, all your personal data and User Content will be permanently removed within 30 days. We may also terminate your account if you violate these Terms.</p>

        <h2>10. Changes to These Terms</h2>
        <p>We may update these Terms from time to time. If we make material changes, we will notify you via email or an in-app notice. Continued use of the App after changes are posted constitutes acceptance of the updated Terms.</p>

        <h2>11. Governing Law</h2>
        <p>These Terms are governed by the laws of England and Wales. Any disputes shall be subject to the exclusive jurisdiction of the courts of England and Wales.</p>

        <h2>12. Contact Us</h2>
        <p>If you have questions about these Terms, contact us at:</p>
        <p>Wolf Technologies Ltd<br />Email: <strong>pete@wolftechnologies.co.uk</strong></p>
      </main>
    </div>
  );
}
